"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var classNames = require("classnames");
var RibbonView = /** @class */ (function (_super) {
    tslib_1.__extends(RibbonView, _super);
    function RibbonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RibbonView.prototype.getLanguage = function () {
        if (this.isEnded()) {
            return this.props.listingStateDescription;
        }
        if (this.isAuction()) {
            return I18n.t('commons.ribbonView.bidNow');
        }
        if (this.hasDiscount()) {
            return this.props.discountDisplay;
        }
        if (this.isOnSale()) {
            return this.props.saleRibbonDisplay;
        }
        if (this.isPriceDrop()) {
            return this.props.priceDropDisplay;
        }
        return false;
    };
    RibbonView.prototype.isEnded = function () {
        return this.props.listingStateSlug !== 'live';
    };
    RibbonView.prototype.isAuction = function () {
        return !!this.props.auction;
    };
    RibbonView.prototype.isOnSale = function () {
        return this.props.saleRibbonDisplay;
    };
    RibbonView.prototype.isPriceDrop = function () {
        return !!this.props.priceDropDisplay;
    };
    RibbonView.prototype.hasDiscount = function () {
        return !!this.props.discountDisplay;
    };
    RibbonView.prototype.renderCallout = function () {
        if (!this.props.callout)
            return;
        return this.props.callout;
    };
    RibbonView.prototype.render = function () {
        var classes = classNames('ribbon-view', {
            'ribbon-view--ended': this.isEnded(),
            'ribbon-view--auction': this.isAuction(),
            'ribbon-view--sale': this.hasDiscount() || this.isOnSale(),
            'ribbon-view--pricedrop': this.isPriceDrop(),
            'ribbon-view--unstyled': this.props.unstyled,
        });
        var language = this.getLanguage();
        if (!language) {
            return null;
        }
        return (React.createElement("div", { className: classes },
            language,
            this.renderCallout()));
    };
    return RibbonView;
}(React.Component));
exports.default = RibbonView;
//# sourceMappingURL=ribbon_view.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/ribbon_view.js
// module id = EijG
// module chunks = 20 21